import { is } from "date-fns/locale";
import { getRowLabelNew } from "../createMatrices";

  export function getRowLabel(
    rowIndex,
    totalRows,
    isReverse,
    useNumbers,
    startFrom
  ) {
    if(!startFrom) return "";
    if (useNumbers) {
      // Ensure startFrom is treated as a number for numeric labels
      const startNumber =
        typeof startFrom === "number" ? startFrom : parseInt(startFrom, 10);
      let label;
      if (isReverse) {
        // Calculate label when counting in reverse from the total number of rows
        label = startNumber + totalRows - 1 - rowIndex;
      } else {
        // Calculate label when counting normally
        label = startNumber + rowIndex;
      }
      return label.toString();
    } else {
      // Ensure startFrom is treated as a string for letter labels
      // const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const startChar =
        typeof startFrom === "string"
          ? startFrom.toUpperCase()
          : String.fromCharCode(65 + (startFrom % 26));
      // console.log(`Start Char: ${startChar}`);
      
      const startIndex = getAlphabetIndex(startChar); // Convert startFrom to its alphabet index
      // console.log(`Start Index: ${startIndex}, Row Index: ${rowIndex}, Total Rows: ${totalRows}, Is Reverse: ${isReverse}`);
      
      let adjustedIndex;
  
      if (isReverse) {
        adjustedIndex = startIndex + totalRows - 1 - rowIndex;
      } else {
        adjustedIndex = startIndex + rowIndex;
      }
  // console.log(`Adjusted Index: ${adjustedIndex}`);
  // console.log(`Label: ${getRepeatingAlphabetLabel(adjustedIndex)}`);
  
      return getRepeatingAlphabetLabel(adjustedIndex);
    }
  }
 export function getAlphabetIndex(label) {
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let index = 0;
  
    for (let i = 0; i < label.length; i++) {
      index *= 26;
      index += alphabet.indexOf(label[i]) + 1;
    }
  
    return index - 1; // Convert to 0-based index
  }
  export function getRepeatingAlphabetLabel(index) {
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let label = '';

  while (index >= 0) {
    label = alphabet[index % 26] + label;
    index = Math.floor(index / 26) - 1; // Move to the next "digit" in base 26
  }

  return label;
}
export const drawSection = (
  context,
  obj,
  canvasOffset,
  zoom,
  selectedCircles,
  HoldTypes,
  seatingTickets,
  eventID
) => {
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
 
  
  const spacing = obj.itemRadius * 2.2; // Adjust spacing based on your needs
  // console.log(obj.matrix);
  let skip = obj.isHidden ?? false;
  if(skip) return;
  if(!obj.matrix || obj.matrix.length === 0) return;
  const totalWidth = spacing * (obj.matrix[0].length - 1) + obj.itemRadius * 2;
  const totalHeight = spacing * (obj.matrix.length - 1) + obj.itemRadius * 2;
  const centerX = obj.x + totalWidth / 2;
  const centerY = obj.y + totalHeight / 2;
  context.save();
  context.scale(zoom, zoom);
  context.translate(centerX + canvasOffset.x, centerY + canvasOffset.y);
  context.rotate((obj.rotation * Math.PI) / 180); // Convert degrees to radians
  context.save(); // Save the current context state, including the non-rotated state
  context.translate(0, -totalHeight / 2 - 20); // Move to the text position
  context.rotate((-obj.rotation * Math.PI) / 180); // Rotate the context for text drawing; convert degrees to radians
  const newFont = zoom >= 0.1 ? 12 / zoom : 12;
  context.fillStyle = "black"; // Text color
  context.font = `${newFont}px Arial`; // Adjust font size and family as needed
  context.textAlign = "center"; // Center the text horizontally
  context.textBaseline = "middle"; // Center the text vertically
  // console.log(obj.hideName);
  
  if(!obj.hideName) context.fillText(obj.name, 0, 0);
  context.restore();
  obj.matrix.forEach((row, rowIndex) => {
    let label = "";
    if(eventID === "Kw09ngSW2Yq2ptUCoWg2") {
      label = getRowLabelNew(
        rowIndex,
        obj.matrix.length,
        obj.isReversedRowLabel,
        obj.useRowLabelNumber,
        obj.startFrom
      ); // Get the letter or letters for the row
    }
    else{
       label = getRowLabel(
      rowIndex,
      obj.matrix.length,
      obj.isReversedRowLabel,
      obj.useRowLabelNumber,
      obj.startFrom
    ); // Get the letter or letters for the row
  }
   if(obj.id === "32b2023b-fe57-414b-9e40-06f704e6bb7b"){
  console.log(rowIndex, obj.startFrom, label);
   }
    
    const rowLength = obj.matrix[0].length;
    const middleIndex = (rowLength - 1) / 2; // Calculate the middle index of the row
    row.forEach((item, columnIndex) => {
      if (obj.matrix[rowIndex][columnIndex].deleted) return;
      let curveFactor = 0;
      if(obj.useCurveRows  && obj.curveFactor ) curveFactor = obj.curveFactor;
      const distanceFromMiddle = Math.abs(columnIndex - middleIndex);
                let curveOffset = 0;
                // Apply a curve formula: The farther from the middle, the lower the y-value
                if(obj.useCurveRows && curveFactor)
                 curveOffset = curveFactor * (1 - (distanceFromMiddle / middleIndex) ** 2);
    
      const assigned = findTicket(obj.matrix[rowIndex][columnIndex].tierID);
      const circleX = columnIndex * spacing - totalWidth / 2 + obj.itemRadius;
      const circleY = rowIndex * spacing - totalHeight / 2 + obj.itemRadius  + curveOffset;

      if (columnIndex === 0) {
        // Check to ensure we're at the start of a row
        const textX = columnIndex * spacing - totalWidth / 2 - obj.itemRadius; // Position the letter to the left of the first item
        let textAfter = 0;
        // console.log(curveFactor);
        
        if(obj.useCurveRows  && curveFactor >0) textAfter = curveFactor - 40;
        const textY = circleY ; // + textAfter Position the letter above the row
        // left
        if(!obj.hideleftRowLabel) {
        context.save(); // Save current state to preserve settings
        context.translate(textX, textY); // Move to the text position
        context.rotate(-obj.rotation * (3.14 / 180)); // Rotate the canvas
        context.scale(zoom, zoom); // Apply zoom

        context.fillStyle = "black"; // Text color
        context.font = `${newFont}px Arial`; // Text styling
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText(label.toString(), 0, 0); 
        context.restore(); // Restore context to previous state
        }
        // right
        if(!obj.hideRightRowLabel) {
        context.save(); // Save current state to preserve settings
        context.translate(-textX, textY); // Move to the text position
        context.rotate(-obj.rotation * (3.14 / 180)); // Rotate the canvas
        context.scale(zoom, zoom); // Apply zoom
        context.fillStyle = "black"; // Text color
        context.font = `${newFont}px Arial`; // Text styling
        context.textAlign = "center";
        context.textBaseline = "middle";        
        context.fillText(label.toString(), 0, 0); 
        context.restore(); // Restore context to previous state
        }
      }
    

      context.beginPath();
      context.arc(circleX, circleY, obj.itemRadius, 0, Math.PI * 2);
      context.fillStyle = obj.color;
      if (item.tierColor && assigned) {
        context.fillStyle = item.tierColor; // Border color for selected circles
      } else context.fillStyle = "black";
      if (item.holdID && item.holdID.trim()) {
        const HoldAccess = HoldTypes.filter(
          (hold) => hold.HoldID === item.holdID
        );
        if (HoldAccess[0].accessCode === null) {
          context.fillStyle = "black";
        } // Border color for selected circles
      }
      if (item.isTaken) {
        context.fillStyle = "black";
      }
      context.fill();
      context.save(); // Save the current context state, including the non-rotated state
      context.translate(circleX, circleY); // Move to the text position
      context.rotate((-obj.rotation * Math.PI) / 180); // Rotate the context for text drawing; convert degrees to radians
      if (
        selectedCircles.some(
          (selection) =>
            selection.objectId === obj.id &&
            selection.rowIndex === rowIndex &&
            selection.columnIndex === columnIndex
        )
      )
        context.fillStyle = "black"; // Text color
      else context.fillStyle = "white"; // Text color
      context.font = `12px Arial`; // Adjust font size and family as needed
      context.textAlign = "center"; // Center the text horizontally
      context.textBaseline = "middle"; // Center the text vertically
      // if (item.holdID) {
      const HoldAccess = HoldTypes.filter(
        (hold) => hold.HoldID === item.holdID
      );
      //   if (HoldAccess[0].accessCode === null) {
      //     context.fillText("X", 0, 0);
      //   } // Border color for selected circles
      // }
      // if (item.isTaken || (item.holdID && HoldAccess[0].accessCode === null))
      //   context.fillText("X", 0, 0);
      // else {
      if (
        selectedCircles.some(
          (selection) =>
            selection.objectId === obj.id &&
            selection.rowIndex === rowIndex &&
            selection.columnIndex === columnIndex
        )
      )
        context.fillText("\u2713", 0, 0);

      // if (
      //   item.holdID &&
      //   HoldAccess[0].accessCode &&
      //   !selectedCircles.some(
      //     (selection) =>
      //       selection.objectId === obj.id &&
      //       selection.rowIndex === rowIndex &&
      //       selection.columnIndex === columnIndex
      //   )
      // )
      //   context.fillText("\u{1F512}", 0, 0);
      if (
        !selectedCircles.some(
          (selection) =>
            selection.objectId === obj.id &&
            selection.rowIndex === rowIndex &&
            selection.columnIndex === columnIndex
        )
      )
        context.fillText(item.name, 0, 0);

      context.restore();
      if (
        selectedCircles.some(
          (selection) =>
            selection.objectId === obj.id &&
            selection.rowIndex === rowIndex &&
            selection.columnIndex === columnIndex
        )
      ) {
        context.strokeStyle = "black";
        context.lineWidth = 2;
        context.stroke();
      }
    });
  });
  context.restore();
};
